import { Box, Circle, Flex, Heading,Input, InputGroup, Text, Tooltip, useClipboard, useColorModeValue, useDisclosure, useMediaQuery } from '@chakra-ui/react'
import React, { useEffect, useState,useCallback } from 'react'
import {   topAddresses } from '../../constants/addresses'
import { useActiveWeb3React } from '../../hooks/useActiveWeb3React'
import NetworkModal from '../../components/Navbar/modals/networkModal'
import useTransactionHistory from '../../hooks/useGetTransaction'
import { isAddress, setUpWeb3WithData, shortenAddress } from '../../utils/utilsFunction'
import ShowContent from './ShowContent'
import { IContext, TextContext } from '../../hooks/context'
import { abis } from '../../constants/erc'
import { ethers } from 'ethers'
import Balances from '../Balances'
import Transaction from './Transaction'
import { CopyIcon, SearchIcon } from '@chakra-ui/icons'

const Home = () => {
  const [displayNetwork, setDisplayNetwork] = useState(false);
  const [symbol,setsymbol] = useState("")
  const {account} = useActiveWeb3React()
  const {showText,setShowText,setAddress,setBalance,address,getValue,setGetValue,setLoad,loading,outgoingTransaction,incomingTransaction,ETHBalance} = React.useContext(TextContext) as IContext

useTransactionHistory(getValue,address)

const { hasCopied, onCopy } = useClipboard(address)

const searchForAddress = () => {
  // get random item from an array
  const randomItem = topAddresses[Math.floor(Math.random()*topAddresses.length)];
  // const randomItem = "0x28c6c06298d514db089934071355e5743bf21d60";
  console.log({randomItem})
  setAddress(randomItem)
  
  if(isAddress(randomItem)){
    setAddress(randomItem)
    setGetValue(!getValue)
   onToggle()
   setShowText(true)
   }
  
}


const getTransaction =async () => {
  console.log("searching...")
 if(isAddress(address)){
  setAddress(address)
  setGetValue(!getValue)
 onToggle()
 setShowText(true)
 }
}
function numberWithCommas(x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  parts[1] = parts[1] && parts[1].slice(0, 2);
  return parts.join(".");
}

const connectWallet = useCallback(()=>{
  if(account){
    setAddress(account)
    setAddress(account)
    setGetValue(!getValue)
    
  }else {
    setDisplayNetwork(true)
  }
},[account])

const { onToggle } = useDisclosure()
  return (
    
    <Box  width={["100%","100%","95%"]} mx="auto" p="0px 5px"  overflowX="hidden" overflowY="hidden" >
{!showText &&<Flex flexDirection={"column"} >
    <Box>

  
      
      
      <Box  padding="15px 10px" margin="auto" mt="30px" borderRadius="30px">
       
        <Box padding= "30px 10px" margin="auto" textAlign="center" color="white">
            <Heading as="h4">Search Crypto Address</Heading>
            <Text my="5px">Hey, 👋🏼 Enter your crypto address below to track its activities</Text>
            <Box display="flex" justifyContent="center" mt="15px" >
 <InputGroup size='sm' width={["100%","100%","430px"]}>
            <Input placeholder="from" color="black" background="white"  height="50px" value={address} onChange={(e) => setAddress(e.target.value)} 
            borderRadius="24px"
            />
               
        </InputGroup>
        <Box backgroundColor="white" 
              display="flex" justifyContent="center" alignItems="center" onClick={()=>{
              setShowText(true)
              getTransaction()
              setLoad(true)
              }} borderRadius="50%" width="50px" height="50px"  ml="10px">
          <SearchIcon  fontSize="24px" color="black"/>
        </Box>
            </Box>
       
        <Flex justifyContent="center" mt="13px">
              <Text onClick={searchForAddress} cursor="pointer" ml="10px" borderRadius="20px" border="1px solid white" fontSize="13px" padding="2px 15px">Random Address</Text>
              <Text onClick={connectWallet} cursor="pointer" ml="10px" borderRadius="20px" border="1px solid white" fontSize="13px" padding="2px 15px">Connect wallet</Text>

            </Flex>
        </Box>
      </Box>
           
    </Box>
  </Flex> 

  
}
  
   {showText && !loading ?
   <Box>
      <Flex borderRadius="4px" margin="auto" gap="0px" padding={["20px 10px","5px 10px","0px 5px"]}        justifyContent="space-between" flexDirection={["column","column","row"]} >
       <Balances /> 
       <ShowContent balance={ETHBalance} symbol={symbol} />
       {/* <Box mt={["100px","100px",0]}>
       </Box>      */} 
        <Box>
    
         <Transaction />
         <Box width={["100%","100%"]} p="20px 10px" fontSize="13px" mt="40px" color="white" >
      <Flex><Text  >Account </Text> <Text ml="3px" mt="0px" fontSize="13px">{shortenAddress(address)}</Text> <Circle ml="13px" size="30px" bg="#9b9898" mt="-2px">
        <Tooltip 
         hasArrow
         label={hasCopied ? "Copied!" : "Copy"}
         bg="gray.300"
         color="black">
           <CopyIcon onClick={onCopy}/>
        </Tooltip>
        </Circle>
       </Flex>
      <Flex my="8px" fontSize="12px" justifyContent="center" >
        <Text mt="4px">{numberWithCommas(ETHBalance)} ETH</Text>
      </Flex>
      <Box my ="5px">
        <Text fontSize="12px">Total Incoming Transactions : <Text as="span" color="#ACACAC" fontWeight={700}>{incomingTransaction?.length}</Text></Text>
        <Text fontSize="12px">Total Outgoing Transactions : <Text as="span" color="#ACACAC" fontWeight={700}>{outgoingTransaction?.length}</Text></Text>
      </Box>

      <Text onClick={searchForAddress} cursor="pointer" ml="10px" borderRadius="5px" border="1px solid white" fontSize="13px" textAlign="center" padding="3px 0" width="130px">Random Address</Text>
    </Box>
  </Box>
      </Flex>

    </Box>
     : 
    showText && loading && <Flex>
   <div className="spanner show">
  <div className="loader"></div>
</div>
   </Flex>
  
   }

        <NetworkModal displayNetwork={displayNetwork} setDisplayNetwork={setDisplayNetwork} />
    </Box>
  )
}

export default Home